import { render, staticRenderFns } from "./HeadCommon.vue?vue&type=template&id=6a7bec5c&scoped=true&"
import script from "./HeadCommon.vue?vue&type=script&lang=js&"
export * from "./HeadCommon.vue?vue&type=script&lang=js&"
import style0 from "./HeadCommon.vue?vue&type=style&index=0&id=6a7bec5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7bec5c",
  null
  
)

export default component.exports